export const calculatePerDaySalary = (basicSalary, extraAllowance, workingDaysInMonth) => {
  const grossSalary = (basicSalary || 0) + (extraAllowance || 0);
  return workingDaysInMonth > 0 ? grossSalary / workingDaysInMonth : 0;
};

export const calculatePerHourSalary = (perDaySalary, totalHours) => {
  return totalHours > 0 ? perDaySalary / totalHours : 0;
};

export const formatAmountForDisplay = (item, workingDays, workingHours) => {
  let numericAmount;

  if (item.amount === "Custom Value" || /^\d+$/.test(String(item.amount))) {
    numericAmount = parseFloat(item.amount);
  } else if (String(item.amount).includes('x') || String(item.amount).includes('day')) {
    const employee = this.employeeList.find(emp => emp.uid === item.employeeId) || { basicSalary: 0, extraAllowance: 0 };
    const perDay = calculatePerDaySalary(employee.basicSalary, employee.extraAllowance, workingDays.length);
    const perHour = calculatePerHourSalary(perDay, workingHours);
    const multiplier = parseFloat(String(item.amount)) || 1;
    const isDay = String(item.amount).includes('day');
    numericAmount = isDay ? perDay * multiplier : perHour * multiplier;
  } else {
    numericAmount = parseFloat(item.amount) || 0;
  }

  return isNaN(numericAmount) ? String(item.amount) : numericAmount.toFixed(2);
};

export const formatAmountForSave = (amount) => {
  if (amount !== "Custom Value" && amount.includes('(')) {
    return amount.match(/\((.*?)\)/)[1]; // Extracts "(1x)" and takes "1x"
  } else if (amount === "Custom Value") {
    return null; // Will be handled by customAmount
  }
  return amount;
};


// WEBPACK FOOTER //
// ./src/utils/perdaySallaryUtils.js